import { CollectionContext, UserInfoContext } from "GlobalContext";
import { AddButton, PageLoading, SiteModal, SiteTable } from "components";
import { RootStackScreenProps } from "navigations";
import React, { useContext, useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import { FetchSites } from "server/collectionConnect";
import { SiteList, SiteModalStatus } from "types";

export function SiteScreen({}: RootStackScreenProps<"Site">) {
  const [editSite, setEditSite] = useState<SiteModalStatus>(null);
  const { userInfo } = useContext(UserInfoContext);
  const { SiteCollection, onSnapShot } = useContext(CollectionContext);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sites, setSites] = useState<SiteList[]>([]);

  useEffect(() => {
    setIsLoading(true);
    if (SiteCollection === null || userInfo === null) {
      onSnapShot("site");
      return;
    }

    const result = FetchSites(userInfo, SiteCollection);
    setSites(result);
    setIsLoading(false);
  }, [SiteCollection, userInfo]);

  if (isLoading) return <PageLoading isLoading={isLoading} />;

  return (
    <>
      <View style={styles.container} />
      <View style={styles.listContainer}>
        <SiteTable
          tableList={sites}
          onEditClick={id => setEditSite({ id: id, isEdit: true })}
        />
      </View>
      <AddButton onClick={() => setEditSite({ id: null, isEdit: false })} />

      <SiteModal
        modalStatus={editSite}
        onCloseModal={() => setEditSite(null)}
      />
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    alignItems: "center",
    padding: 10,
  },
  listContainer: {
    flex: 8,
    backgroundColor: "#fff",
  },
  footerContainer: {
    flex: 1,
    backgroundColor: "#fff",
  },
  headingText: {
    fontSize: 32,
    marginBottom: 20,
  },
});
